'use strict';

export default function routes($stateProvider) {
    'ngInject'

    $stateProvider.state('main.retry', {
        url: 'retry',
        template: '<retry></retry>'
    });
}



// WEBPACK FOOTER //
// ./public/dev/app/retry/retry.routes.js